export const contactusValidate = (foramData) => {

    const errors = {}

    if (!foramData.fullName.trim()) {
        errors.fullName = "لطفا عنوان را وارد کنید"
    } else {
        delete errors.fullName
    }

    if (!foramData.company.trim()) {
        errors.company = "لطفا عنوان را وارد کنید"
    } else {
        delete errors.company
    }

    if (!foramData.email.trim()) {
        errors.email = "لطفا عنوان را وارد کنید"
    } else {
        delete errors.email
    }

    if (!foramData.phoneNumber.trim()) {
        errors.phoneNumber = "لطفا عنوان را وارد کنید"
    } else {
        delete errors.phoneNumber
    }

    if (!foramData.message.trim()) {
        errors.message = "لطفا عنوان را وارد کنید"
    } else {
        delete errors.message
    }

    return errors;

}